import { render, staticRenderFns } from "./activeDetail.vue?vue&type=template&id=7494ec97&scoped=true"
import script from "./activeDetail.vue?vue&type=script&lang=js"
export * from "./activeDetail.vue?vue&type=script&lang=js"
import style0 from "./activeDetail.vue?vue&type=style&index=0&id=7494ec97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7494ec97",
  null
  
)

export default component.exports